import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { CounsellorPersonalDetailsVM } from "../models/CounsellorPersonalDetailsVM";
import { CounsellorProfilePrefVM } from "../models/CounsellorProfilePrefVM";
import { CounsellorAvailabilityVM } from "../models/CounsellorAvailabilityVM";
import { OrganisationDashboardVM } from "../models/OrganisationDashboardVM";
import { OrganisationProfileVM } from "../models/OrganisationProfileVM";
import { OrganisationContractVM } from "../models/OrganisationContractVM";
import { OrganisationClientVM } from "../models/OrganisationClientVM";
import { OrganisationIssueCreditVM } from "../models/OrganisationIssueCreditVM";
import { OrganisationProfessionalVM } from "../models/OrganisationProfessionalVM";
import { OrganisationSessionPreferencesVM } from "../models/OrganisationSessionPreferencesVM";
import { HttpClient } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class AccountService extends BaseService {

  dashboard: OrganisationDashboardVM;
  profile: OrganisationProfileVM;

  constructor(private http: HttpClient) {
    super();
  }

  public getDashboard(): Observable<OrganisationDashboardVM> {
    const url = '/api/account/dashboard';
    return this.http.get(url, this.getHttpOptions(true)).pipe(
      tap(x => this.dashboard = x as OrganisationDashboardVM),
      map(resp => resp as OrganisationDashboardVM));
  }

  public updatePersonalDetails(vm: OrganisationProfileVM): Observable<boolean> {
    return this.http.post('/api/account/profile/personal-details', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public getProfile(): Observable<OrganisationProfileVM> {
    return this.http.get('/api/account/profile', this.getHttpOptions(true)).pipe(
      tap(x => this.profile = x as OrganisationProfileVM),
      map(resp => resp as OrganisationProfileVM),)
  }

  public getContracts(status: boolean): Observable<OrganisationContractVM[]> {
    if (status) {
      return this.http.get('/api/account/contracts/active', this.getHttpOptions(true)).pipe(
        map(resp => resp as OrganisationContractVM[]));
    }
    else {
      return this.http.get('/api/account/contracts/expired', this.getHttpOptions(true)).pipe(
        map(resp => resp as OrganisationContractVM[]));
    }
  }

  public getClients(status: boolean): Observable<OrganisationClientVM[]> {
    if (status) {
      return this.http.get('/api/account/clients/true', this.getHttpOptions(true)).pipe(
        map(resp => resp as OrganisationClientVM[]));
    }
    else {
      return this.http.get('/api/account/clients/false', this.getHttpOptions(true)).pipe(
        map(resp => resp as OrganisationClientVM[]));
    }
  }

  public addClient(vm: OrganisationClientVM): Observable<boolean> {
    return this.http.post('/api/account/clients', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public disableClient(vm: OrganisationClientVM): Observable<boolean> {
    return this.http.post('/api/account/clients/disable', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public enableClient(vm: OrganisationClientVM): Observable<boolean> {
    return this.http.post('/api/account/clients/enable', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public issueSession(vm: OrganisationIssueCreditVM): Observable<boolean> {
    return this.http.post('/api/account/issue-session', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public getProfessionals(status: boolean): Observable<OrganisationProfessionalVM[]> {
    if (status) {
      return this.http.get('/api/account/professionals/true', this.getHttpOptions(true)).pipe(
        map(resp => resp as OrganisationProfessionalVM[]));
    }
    else {
      return this.http.get('/api/account/professionals/false', this.getHttpOptions(true)).pipe(
        map(resp => resp as OrganisationProfessionalVM[]));
    }
  }

  public addProfessional(vm: OrganisationProfessionalVM): Observable<OrganisationProfessionalVM> {
    return this.http.post('/api/account/professionals', vm, this.getHttpOptions(true)).pipe(
      map(resp => resp as OrganisationProfessionalVM));
  }

  public reissueJoiningCode(vm: OrganisationProfessionalVM): Observable<any> {
    return this.http.post('/api/account/professionals/re-issue-joiningcode', vm, this.getHttpOptions(true)).pipe(
      map(resp => resp));
  }

  public disableProfessional(vm: OrganisationProfessionalVM): Observable<boolean> {
    return this.http.post('/api/account/professionals/disable', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public enableProfessional(vm: OrganisationProfessionalVM): Observable<boolean> {
    return this.http.post('/api/account/professionals/enable', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public getSessionPreferences(): Observable<OrganisationSessionPreferencesVM> {
    return this.http.get('/api/account/session-preferences', this.getHttpOptions(true)).pipe(
      map(resp => resp as OrganisationSessionPreferencesVM));
  }

  public updateSessionPreferences(vm: OrganisationSessionPreferencesVM): Observable<OrganisationSessionPreferencesVM> {
    return this.http.post('/api/account/session-preferences', vm, this.getHttpOptions(true)).pipe(
      map(resp => resp as OrganisationSessionPreferencesVM));
  }

}
